import { FETCH_CUSTOMER, FETCH_CUSTOMER_BY_ID } from '../types';

import * as api from '../../api';

export const getAllCustomer = () => async (dispatch) => {
  try {
    const { data } = await api.allCustomer();

    // console.log('getData in action :', data);

    dispatch({ type: FETCH_CUSTOMER, payload: data });
  } catch (error) {
    console.log(error.message);
  }
};
export const getSingleCustomer = (id) => async (dispatch) => {
  try {
    const { data } = await api.singleCustomer(id);

    // console.log('getData in action :', data);

    dispatch({ type: FETCH_CUSTOMER_BY_ID, payload: data });
  } catch (error) {
    console.log(error.message);
  }
};
// export const getPosts = (page) => async (dispatch) => {
//   try {
//     const {
//       data: { data, currentPage, numberOfPages },
//     } = await api.fetchPosts(page);

//     console.log('getData in action :', data);

//     dispatch({
//       type: FETCH_ALL,
//       payload: { data, currentPage, numberOfPages },
//     });
//   } catch (error) {
//     console.log(error.message);
//   }
// };

// export const createPost = (post) => async (dispatch) => {
//   try {
//     const { data } = await api.createPost(post);

//     dispatch({ type: CREATE, payload: data });
//     console.log('create in action :', data);
//   } catch (error) {
//     console.log(error.message);
//   }
// };

// export const updatePost = (id, post) => async (dispatch) => {
//   try {
//     const { data } = await api.updatePost(id, post);

//     dispatch({ type: UPDATE, payload: data });
//     console.log('update in action :', data);
//   } catch (error) {
//     console.log(error.message);
//   }
// };

// export const deletePost = (id) => async (dispatch) => {
//   try {
//     await api.deletePost(id);
//     dispatch({ type: DELETE, payload: id });
//   } catch (error) {
//     console.log(error.message);
//   }
// };

// export const likePost = (id) => async (dispatch) => {
//   try {
//     const { data } = await api.likePost(id);

//     dispatch({ type: LIKE, payload: data });
//   } catch (error) {
//     console.log(error);
//   }
// };

// export const getPostBySearch = (searchQuery) => async (dispatch) => {
//   try {
//     const {
//       data: { data },
//     } = await api.fetchPostsBySearch(searchQuery);
//     console.log('data search', data);
//     dispatch({ type: FETCH_BY_SEARCH, payload: data });
//   } catch (error) {
//     console.log(error);
//   }
// };
